import React from "react"

import { Chip } from "@material-ui/core"
import { fullDatetime } from "@/utils/time"

import useStyles from "@/pages/Admin/TrackableLinks/TrackableLinkMetrics/TrackableLinkInteractions/TrackableLinkInteractionChip/styles"

type TrackableLinkInteractionChipProps = {
	type: "click" | "sent-message"
	interactionDate: Date | null
}

type TrackableLinkInterationTypeToChipConfig = Record<TrackableLinkInteractionChipProps["type"], { className: string; label: string }>

const TrackableLinkInteractionChip: React.FC<TrackableLinkInteractionChipProps> = (props) => {
	const { type, interactionDate } = props
	const classes = useStyles()

	const chipConfig = () => {
		if (!interactionDate) {
			return {
				className: classes.notSentMessageChip,
				label: "Não enviou mensagem"
			}
		}

		const trackableLinkInteractionChipMap: TrackableLinkInterationTypeToChipConfig = {
			click: {
				className: classes.clickedChip,
				label: fullDatetime(new Date(interactionDate))
			},
			"sent-message": {
				className: classes.sentMessageChip,
				label: fullDatetime(new Date(interactionDate))
			}
		}

		return trackableLinkInteractionChipMap[type] || null
	}

	return (
		<Chip
			className={chipConfig().className}
			label={chipConfig().label}
			size="small"
		/>
	)
}

export default TrackableLinkInteractionChip
